import React from "react";
import { StyledFooter } from "./FooterTW.styled";

const FooterTW: React.FC = () => {
  return (
    <StyledFooter className="garena-footer">
      <div className="container">
        <div className="remind-text">
          <p>
            ※若消費者為限制行為能力人或無行為能力人，應於消費者之法定代理人閱讀、瞭解並同意
            <a
              href="https://terms.support.garena.com/tw"
              target="_blank"
              rel="noreferrer noopener"
            >
              本契約
            </a>
            之所有內容後，方得使用本遊戲服務，本契約條款變更時亦同。
            <br />
            ※如為未滿20歲之未成年使用者，需經由家長同意方可購買與使用商城服務。
          </p>
        </div>
        <div className="bottom">
          <div className="logos" />
          <div className="cnt">
            <div className="copyrights">
              Copyright © Garena Online. Trademarks belong to their respective
              owners. All Rights Reserved. Copyright © Riot Games, Inc.
              &quot;Riot Games&quot; and &quot;League of Legends&quot; are
              trademarks,service marks and/or registered trademarks throughout
              the world. All rights reserved.
            </div>
            <div>
              <div className="links">
                <a
                  href="//dlgarenanow-a.akamaihd.net/mgames/spdtw/spdcenter/footer/LicensePage/license.html"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">授權資訊</div>
                </a>
                <a
                  href="//tw.support.garena.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">客服中心</div>
                </a>
                <a
                  href="//service.garena.tw/standard/1"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">服務條款</div>
                </a>
                <a
                  href="//www.facebook.com/LeagueOfLegendsTaiwan/"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="link"
                >
                  <div className="link-txt">官方粉絲團</div>
                </a>
              </div>
            </div>
          </div>
          <div className="lv">
            <div className="lv-icon--12" />
            <div className="lv-text">
              <p>
                本遊戲為免費使用，遊戲情節涉及暴力、菸酒畫面。
                <br />
                遊戲內另提供購買虛擬遊戲幣、物品等付費服務。
                <br />
                請注意遊戲時間，避免沈迷。
              </p>
              <div className="service-region">
                本遊戲服務區域為台灣、香港、澳門。
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledFooter>
  );
};

export default FooterTW;
